(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            convertToISOString: convertToISOString,
            dateformat: dateformat,
            jdateToDate: jdateToDate,
            addDays: addDays,
            newDate: newDate,
            toTehranTime: toTehranTime,
            changeJDateTimeToTehran: changeJDateTimeToTehran,
            convertToPersianDate: convertToPersianDate

        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return newDate(date);
            } else {
                return null;
            }
        }

        function convertToISOString(date) {

            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var dt = date.getDate();

            if (dt < 10) {
                dt = '0' + dt;
            }
            if (month < 10) {
                month = '0' + month;
            }
            return (year + '-' + month + '-' + dt);
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }

        function jdateToDate(jdate) {
            var date = jdate.to_gregorian();
            date.setTime(jdate.getTime());
            return date;
        }

        function addDays(date, days) {

            date.setDate(date.getDate() + days);
            return date;
        }

        function newDate(date) {

            if (!date)
                return new Date();
            var ad = new Date(date); /// not work on safari !!

            if (!isDateValid(ad))
                ad = new Date(date.replace(/-/g, "/"));

            return ad;

        }

        function toTehranTime(date) {

            var d = moment(date);
            var tehranTime = d.tz("Asia/Tehran");
            return tehranTime;
        }

        function isDateValid(date) {
            if (isNaN(date.getTime())) {
            } else {
                return true;
            }
        }

        function changeJDateTimeToTehran(jdate) {
            //check time of the year
            var isDST = true;
            if (isDST) {
                var hours = jdate.getHours();
                jdate._d.setHours(hours + 1);
            }

            return jdate;
        }

        function convertToPersianDate(input) {
            var inputDate = new Date(input);
            var tehranTimeZone = convertTZ(inputDate, 'Asia/Tehran')
            var date = new JDate(tehranTimeZone);
            return date;
        }

        function convertTZ(date, tzString) {
            return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));
        }


    }

})();
